import { computed, inject, Injectable, output, signal } from '@angular/core';
import { ChapterService } from './chapter/chapter.service';
import { FacetModel } from './facet/facet.model';
import { MyHistoryScreen } from './my-history-screen';

@Injectable({
  providedIn: 'root',
})
export class MyHistoryUiService {
  private chapterService = inject(ChapterService);
  private isCreatingFacet = signal(false);

  isSubmitRequested = signal({});

  readonly screen = signal<MyHistoryScreen | null>(null);
  // readonly isStoryFormDialogOpened = signal(false);
  readonly isFacetFormDialogOpened = computed(() => !!this.chapterService.selectedFacet() || this.isCreatingFacet());
  readonly isAllChaptersFormDialogOpened = computed(() => !!this.chapterService.selectedFacets().length);
  readonly isChapterScreen = computed(() => this.screen() === MyHistoryScreen.chapter);
  readonly isChaptersScreen = computed(() => this.screen() === MyHistoryScreen.chapters);

  setScreen(screenType: MyHistoryScreen) {
    this.screen.set(screenType);
  }

  openCreateFacetDialog() {
    this.closeFacetsFormDialogs();
    this.isCreatingFacet.set(true);
  }

  openEditFacetDialog(facet: FacetModel) {
    this.closeFacetsFormDialogs();
    this.chapterService.setSelectedFacet(facet);
  }

  openEditAllFacetsDialog() {
    this.closeFacetsFormDialogs();
    this.chapterService.setSelectedAllFacets();
  }

  // openAddStoryDialog() {
  //   this.closeAllDialogs();
  //   // this.isStoryFormDialogOpened.set(true);
  // }

  closeFacetsFormDialogs() {
    this.chapterService.setSelectedFacet(null);
    this.chapterService.setUnselectedAllFacets();
    this.isCreatingFacet.set(false);
  }

  // closeStoryFormDialog() {
  //   this.isStoryFormDialogOpened.set(false);
  // }

  clearUiState() {
    this.closeAllDialogs();
  }

  closeAllDialogs() {
    this.closeFacetsFormDialogs();
    // this.closeStoryFormDialog();
  }

  emitSubmit() {
    this.isSubmitRequested.set({});
  }
}
